import { lazy } from "react";
import { Switch, Route, Redirect } from "react-router";
import { HashRouter } from "react-router-dom";
import AppProvider from "../components/AppProvider";

const AppRoute = lazy(() => import("./app"));
const SignUpRoute = lazy(() => import("./sign-up"));
const MaryKaySignUpRoute = lazy(() => import("./sign-up/mary-kay"));
const PartnerSignUp = lazy(() => import("./sign-up/partner"));
const LoginRoute = lazy(() => import("./login"));
const PrivacyRoute = lazy(() => import("./privacy"));
const TermsRoute = lazy(() => import("./terms"));
const ToSRoute = lazy(() => import("./tos"));
const PasswordResetRoute = lazy(() => import("./password-reset"));
const ExtensionRoute = lazy(() => import("./extension"));
const ConfirmPasswordResetRoute = lazy(() =>
  import("./password-reset/confirm")
);

const RsvpRoute = lazy(() => import("./rsvp"));
const LinkCaptureRoute = lazy(() => import("./link"));
const ContactCaptureRoute = lazy(() => import("./contact"));
const IntegrationRedirectRoute = lazy(() => import("./integration-redirect"));

function RootRoute() {
  return (
    <AppProvider router={HashRouter}>
      <Switch>
        <Route
          path="/sign-up/mary-kay/:afterSaml?"
          component={MaryKaySignUpRoute}
        />
        <Route
          path="/sign-up/partner/:encodedName/:encodedId/:encodedPlan"
          component={PartnerSignUp}
        />
        <Route path="/sign-up/:skipioPlanId?" component={SignUpRoute} />
        <Route path="/app" component={AppRoute} />
        <Route path="/login/:flash?" component={LoginRoute} />
        <Route
          path="/password-reset/:id"
          component={ConfirmPasswordResetRoute}
        />
        <Route path="/password-reset" component={PasswordResetRoute} />
        <Route path="/privacy" component={PrivacyRoute} />
        <Route path="/terms" component={TermsRoute} />
        <Route path="/tos/:slug?" component={ToSRoute} />
        <Route path="/rsvp/:eventId" component={RsvpRoute} />
        <Route path="/link/:formId" component={LinkCaptureRoute} />
        <Route path="/contact/:contactId" component={ContactCaptureRoute} />
        <Route path="/extension" component={ExtensionRoute} />
        <Route
          path="/integration-redirect"
          component={IntegrationRedirectRoute}
        />
        <Redirect to="/app" />
      </Switch>
    </AppProvider>
  );
}

export default RootRoute;
